// noinspection JSUnusedGlobalSymbols
export function getCreditCardURL(memberId, returnUrl) {
  return (dispatch, getState) => {
    return dispatch({
      type: 'card/GET_URL',
      getState,
      returnUrl,
      payload: {
        request: {
          method: 'get',
          url: '/v2/members/payment/url?memberId=' + memberId
        }
      }
    });
  };
}

// noinspection JSUnusedGlobalSymbols
export function getCompanyCreditCardURL(companyId) {
  return (dispatch, getState) => {
    return dispatch({
      type: 'card/GET_URL',
      getState,
      payload: {
        request: {
          method: 'get',
          url: '/v2/members/payment/url?companyId=' + companyId
        }
      }
    });
  };
}

// noinspection JSUnusedGlobalSymbols
export function createCreditCard(memberId, orderCode) {
  return (dispatch, getState) => {
    return dispatch({
      type: 'card/CREATE',
      getState,
      payload: {
        request: {
          method: 'put',
          url: '/v2/members/' + memberId + '/payment',
          data: {
            orderCode: orderCode
          }
        }
      }
    });
  };
}

// noinspection JSUnusedGlobalSymbols
export function getCreditCardInfo(id) {
  return (dispatch, getState) => {
    return dispatch({
      type: 'card/GET',
      getState,
      payload: {
        request: {
          method: 'get',
          url: '/v2/members/' + id + '/payment'
        }
      }
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/creditCard.js
 **/